export default "__VITE_ASSET__BP7A$Yb9__"